import { formatDollar } from 'helpers/formatters';

export const columnDefs = [
    {
        headerName: 'Location Name',
        field: 'locationName',
        cellStyle: { textAlign: 'left' },
    },
    {
        headerName: 'Zone',
        field: 'zone',
    },
    {
        headerName: 'TCV',
        field: 'tcv',
        type: 'numericColumn',
        valueFormatter: ({ value }: any) => formatDollar(value, 0),
    },
    {
        headerName: 'Final Rate',
        field: 'finalRate',
        type: 'numericColumn',
    },
    {
        headerName: 'Program Premium',
        field: 'programPremium',
        type: 'numericColumn',
        valueFormatter: ({ value }: any) => formatDollar(value, 0),
    },
];

export const defaultColDef = {
    resizable: true,
    sortable: false,
    filter: false,
};
